import { render, staticRenderFns } from "./platformWinloseExportFull.vue?vue&type=template&id=6ca84846&lang=pug"
import script from "./platformWinloseExportFull.vue?vue&type=script&lang=js"
export * from "./platformWinloseExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports